/*
    This file uses config settings from /domain-group/domainGroupID/js/config.js
*/

// List scroll event listeners as passive
jQuery.event.special.touchstart = {
    setup: function (_, ns, handle) {
        if (ns.includes('noPreventDefault')) {
            this.addEventListener('touchstart', handle, { passive: false });
        } else {
            this.addEventListener('touchstart', handle, { passive: true });
        }
    },
};

jQuery.event.special.touchmove = {
    setup: function (_, ns, handle) {
        if (ns.includes('noPreventDefault')) {
            this.addEventListener('touchmove', handle, { passive: false });
        } else {
            this.addEventListener('touchmove', handle, { passive: true });
        }
    },
};

var active_menu = active_menu || 0;
var windowWidth = $(window).width();
if (windowWidth > 1025 && active_menu === 1) {
    $('.content_filter').removeClass('closed_menu').addClass('open_menu');

    $(".content_filter li[data-parent-data-id='1']").show();
    // $("#main_nav ul li a[data-id='1'] span").css("display", "inline-block");
} else if (windowWidth > 1025 && active_menu === 3) {
    $('.content_filter').removeClass('closed_menu').addClass('open_menu');

    $(".content_filter li[data-parent-data-id='3']").show();
}

var popupRecaptcha;
var contactRecaptcha;
var reCaptchaReady = false;
var reCaptchaCallback;
var editComment;

if (typeof refreshDeprecatedStyles === 'undefined') {
    var refreshDeprecatedStyles = function () {};
}

function onloadCallback() {
    grecaptcha.ready(function () {
        grecaptcha
            .execute(window.RECAPTCHA_SITEKEY, {
                action: 'submit',
            })
            .then(function (token) {
                $('input[name="g-recaptcha-response"]').val(token);
            });
    });

    reCaptchaReady = true;
    // if captcha loads later then we wanted to render the captcha's, run the callback so captcha's are rendered.
    if (typeof reCaptchaCallback === 'function') {
        reCaptchaCallback();
    }
}

var loadRecaptcha = function () {
    if (!reCaptchaReady && window.RECAPTCHA_SITEKEY) {
        $.getScript(
            'https://www.google.com/recaptcha/api.js?onload=onloadCallback&render=' + window.RECAPTCHA_SITEKEY
        );
    }
};

$('#register-form').one('focusin', function () {
    loadRecaptcha();
});

$('.contact').one('focusin', function () {
    if ($('#contactRecaptcha').length && !$('#contactRecaptcha').data('recaptcha')) {
        loadRecaptcha();
        $('#contactRecaptcha').data('recaptcha', true);
    }
});

$('.contact-form').one('focusin', function () {
    loadRecaptcha();
});

$('.post_comment').one('focusin', function () {
    loadRecaptcha();
});

var loadNkFifaCaptcha = function () {
    if (!reCaptchaReady) {
        reCaptchaCallback = loadNkFifaCaptcha;
        return;
    }

    nkFifaRecaptcha = grecaptcha.render('nkFifaRecaptcha', {
        sitekey: window.RECAPTCHA_SITEKEY,
        theme: 'light',
    });
};

var slickIsActive = false;
// Toggle slick function
var toggleSlick = function () {
    var windowWidth = $(window).width();
    if (windowWidth < defaultConfig.slickActiveWidth && !slickIsActive) {
        slickIsActive = true;
        $('#list_featured').each(function () {
            $(this).slick({
                dots: true,
            });
        });
        refreshDeprecatedStyles();
    } else if (windowWidth > defaultConfig.slickActiveWidth && slickIsActive) {
        slickIsActive = false;
        $('#list_featured').each(function () {
            $(this).slick('unslick');
        });
    }

    if (windowWidth < 1025 && active_menu == 2) {
        $('.mc_top').removeClass('content_filter');
    } else if (windowWidth >= 1025 && active_menu == 2) {
        $('.mc_top').addClass('content_filter');
    } else if ((windowWidth >= 1025 && active_menu === 1) || (windowWidth >= 1025 && active_menu === 3)) {
        $('.content_filter').removeClass('closed_menu').addClass('open_menu');
    } else if ((windowWidth < 1025 && active_menu === 1) || (windowWidth < 1025 && active_menu === 3)) {
        $('.content_filter').removeClass('open_menu').addClass('closed_menu');
        $("#main_nav ul li a[data-id='2'] span").css('display', 'none');
    }
};

$(document).ready(function () {
    if ($('#VP_cookie').length) {
        $('body').addClass('noscroll');
    }

    // Call slick to check if it needs to be initialized on page load
    toggleSlick();

    if ($('#nkFifaRecaptcha').length && !$('#nkFifaRecaptcha').data('recaptcha')) {
        loadNkFifaCaptcha();
        $('#nkFifaRecaptcha').data('recaptcha', true);
    }

    // ACTIVE NAV ITEM CENTER
    //

    if (windowWidth < defaultConfig.slickActiveWidth) {
        slickIsActive = true;
        var showDots = true;

        $('.list').each(function () {
            $(this).slick({
                slide: 'li',
                infinite: true,
                dots: showDots,
                swipe: true,
                //autoplay:true,
                autoplaySpeed: 2000,
                speed: 300,
                slidesToShow: 1,
                arrows: true,
                adaptiveHeight: true,
            });
        });
        refreshDeprecatedStyles();
    } else if (windowWidth >= 1030) {
        var didScroll = false;
        var scrollDiff = [];

        window.onscroll = doThisStuffOnScroll;

        function doThisStuffOnScroll() {
            didScroll = true;
        }

        setInterval(function () {
            if (didScroll) {
                didScroll = false;

                if (scrollDiff.length >= 2) {
                    scrollDiff.shift();
                    scrollDiff.push($(window).scrollTop());
                } else {
                    scrollDiff.push($(window).scrollTop());
                }

                var scrollDiffValue = scrollDiff[1] - scrollDiff[0];

                if ($(window).scrollTop() > 250) {
                    if (scrollDiffValue < 0) {
                        $('.content_filter').removeClass('scrolling');
                    } else {
                        $('.content_filter, #head').addClass('scrolling');
                        $('.content_filter').addClass('head-small');
                    }
                } else if ($(window).scrollTop() < 250) {
                    $('#head').removeClass('scrolling');
                    $('.content_filter').removeClass('head-small');
                }
            }
        }, 200);
    }

    if ((windowWidth < 1020 && active_menu == 1) || (windowWidth < 1020 && active_menu == 2)) {
        // $(".content_filter").css("visibility", "hidden");
        function explode() {
            $('.content_filter').css('visibility', '');
        }

        setTimeout(explode, 1000);
    }

    $('.date-filter li').click(function () {
        $('.date-filter li').removeClass('active').addClass('not-active');
        $(this).toggleClass('not-active active');
    });

    var subMenuItem = $('.content_filter ul li.active');
    var mcDayMenuItem = $('.mc_top ul li.active');

    var subMenuContainer = $('.content_filter .overflow_wrap');
    var subMenuContainerMatchcenter = $('.mc_top .overflow_wrap');

    var mainMenuItem = $('#main_nav ul li.active');
    var mainMenuContainer = $('#main_nav .overflow_wrap_second');

    function centerActiveItem(item, container) {
        // var itemOffset = $(item).offset();
        var itemOffset = item[0].offsetLeft;
        var itemWidth = $(item).width();
        // Button width is 60
        var windowWidth = $(window).width();

        // Linkant van de knop vanaf window links
        // var offset = itemOffset.left;

        var width = itemWidth;
        // Midden van de knop, vanaf window links
        var centerOffset = itemOffset + width / 2;
        // Center screen

        var center = windowWidth / 2;
        var scrollToLeft = centerOffset - center;

        $(container).scrollLeft(scrollToLeft);
    }

    if (mcDayMenuItem.length > 0) {
        centerActiveItem(mcDayMenuItem, subMenuContainerMatchcenter);
    }

    if (mainMenuItem.length > 0 && windowWidth < 1030) {
        //console.log(mainMenuItem.width(), 0, mainMenuContainer.width());
        centerActiveItem(mainMenuItem, mainMenuContainer);
    }

    //
    // NAVIGATION - VIGNET SCROLL - BACK BUTTON
    $('.back_btn').on('click', function () {
        event.preventDefault();
        $('.open_menu').toggleClass('open_menu closed_menu');
    });

    var openedMenuDataId = undefined;
    $('#main_nav ul li a').click(function (event) {
        event.preventDefault();
        var viewportWidth = $(window).width();
        $(window).resize(function () {
            viewportWidth = $(window).width();
        });

        var dataId = $(this).data('id');
        var subMenu = $('.content_filter');

        if (
            viewportWidth < 1025 &&
            dataId !== undefined &&
            $(".content_filter li[data-parent-data-id='" + dataId + "']").length
        ) {
            // Exception: do not toggle when opening a different submenu
            if (openedMenuDataId === undefined || openedMenuDataId == dataId) {
                subMenu.toggleClass('open_menu closed_menu');
            }

            $('.content_filter li').hide();
            $(".content_filter li[data-parent-data-id='" + dataId + "']").show();

            openedMenuDataId = dataId;
        } else {
            window.location.href = $(this).attr('href');
        }
    });

    $(document).on('click', '.filter_small', function () {
        $('.filter_small').removeClass('inactive');
        $('.filter_big').removeClass('clicked');
        $('.filter_big').addClass('inactive');
        $('li.article').removeClass('big');
        $('li.article').addClass('small');
        $('li.title').removeClass('big');
        $('li.title').addClass('small');

        setCookie('display_articles', 'small', 365);
    });

    $(document).on('click', '.filter_big', function () {
        $('.filter_big').removeClass('inactive');
        $('.filter_small').addClass('inactive');
        $('li.article').removeClass('small');
        $('li.article').addClass('big');
        $('li.title').removeClass('small');
        $('li.title').addClass('big');

        setCookie('display_articles', 'big', 365);
    });

    function getCookie(cname) {
        var name = cname + '=';
        var ca = document.cookie.split(';');
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
                return c.substring(name.length, c.length);
            }
        }
        return '';
    }

    var articleDisplay = getCookie('display_articles');
    var fired = false;
    $(document).on('click', '.loadmore', function () {
        fired = false;
    });

    if (articleDisplay === 'big') {
        $('.async-iframe').each(function () {
            $(this).html(
                '<iframe src="' +
                    $(this).data('src') +
                    '" width="100%" height="100%" frameborder="0" allowfullscreen></iframe>'
            );
        });
    }

    $(window).on('scroll', function () {
        var scrollTop = $('body').scrollTop();
        if (articleDisplay == 'big' && scrollTop > 500 && fired == false) {
            $('.news.big li').each(function () {
                var imgSRC = $(this).children('figure').children('img').attr('src');
                var img = $(this).children('figure').children('img');
                var figureSRC = $(this).children('figure').data('imgurl');
                if (imgSRC == '') {
                    $(img).attr('src', figureSRC);
                } else {
                    //
                    //console.log("Wel afbeelding");
                }
            });
            fired = true;
        }
    });

    // Add close function to invasive bar
    $('.x-icon').on('click', function (event) {
        $('.invasive-bar').addClass('hidden');
        event.preventDefault();
    });

    // CREATE USER AND REGISTER TABS
    $('#user_login').tabs();

    $(document).on('click', '.refresh', function () {
        window.location.reload();
    });

    // COOKIE TRANSFERGERUCHTEN
    $('aside.regular-poll input').on('change', function (event) {
        var pollAnswer = $(this).filter(':checked').val();
        if (pollAnswer == undefined) {
            alert('We hebben geen stem van je ontvangen.');
        } else {
            $.post('/requests/', {
                pollQuestionID: $('#pollQuestionID').val(),
                poll: pollAnswer,
            }).done(function (data) {
                console.log($('aside.regular-poll'), data);
                $('aside.regular-poll').replaceWith(data);
            });
        }
        event.preventDefault();
    });

    $(document).on('click', "#poll input[type='radio']", function () {
        if ($("#poll input[type='radio']").is(':checked')) {
            $(this).parent().addClass('really_checked');
        } else if ($("#poll input[type='radio']").not(':checked')) {
            $(this).parent().removeClass('really_checked');
        }
    });

    // CLOSE PASSWORD FORGOTTEN FORM BY CHANGE TABS
    $('.forget_password').on('click', function (event) {
        event.preventDefault();
        $('#login-form').css('display', 'none');
        $('#password_forgotten_form').css('display', 'block');
    });

    if ($('#contact_errors')[0]) {
        $('main .content .static_page .contact').css('border-top', '0px');
    }

    // Check weither user is logged in for commenting
    $('.submit_news').on('click', function (e) {
        var textarea = $(this).parents('form').find('textarea').val();

        if ($.trim(textarea).length > 0) {
            if ($(this).hasClass('logged-in')) {
                // Submit form
            } else {
                e.preventDefault();
                $('.login-modal').addClass('active');
                $('body').addClass('noscroll'); //ADD THIS

                // Only load recaptcha on form focus
                $('#login_form, #register_form').one('focusin', function () {
                    loadRecaptcha();
                    $('#popupRecaptcha').data('recaptcha', true);
                });

                // Div with an id
                var form = $(this).parents('form');
                var targetId = form.parent().attr('id');
                var formValue = form.find('textarea').val();

                if (formValue.length !== 0) {
                    // if not logged in store comment on login or register
                    $(document).on(
                        'click',
                        '.login-modal .facebook, .login-modal input[type="submit"]',
                        function () {
                            var message = formValue;
                            store('commentMessage', {
                                message: message,
                                target: targetId,
                            });
                        }
                    );
                }
            }
        } else {
            //Stop posting because there is nothing or just a space
            e.preventDefault();
            return;
        }
    });

    $(document).on('submit', 'form', function (event) {
        var recaptchaInput = $(this);

        recaptchaInput.addClass('loading');
        loadRecaptcha();
    });

    function addTokenToHtml(html, token) {
        var element =
            html instanceof jQuery
                ? html.find('[name=g-recaptcha-response]')
                : $(html).find('[name=g-recaptcha-response]');
        element.val(token);
    }

    if (store('commentMessage')) {
        var message = store('commentMessage');
        var target = $('#' + message.target);
        target.find('textarea').val(message.message);

        var button = target.siblings('button.answer');
        button.addClass('active');
        $('.comment' + button.attr('id')).show();

        // empty storage when textarea is filled
        store('commentMessage', null);

        var scrollto = $('#' + message.target).offset().top - 130;
        $('html, body').animate(
            {
                scrollTop: scrollto,
            },
            'slow'
        );
    }

    // CHECK IF THE USER IS ON THE RIGHT PAGE
    if ($('ul.video-list, ul.gallery').length) {
        var video = $('ul.video-list').length;

        // AJAX INFINITE SCROLL
        var ias = jQuery.ias({
            container: 'ul.video-list',
            item: 'li',
            pagination: '.pagination',
            next: 'a.next',
        });

        ias.on('load', function (event) {
            event.url = routePrefix + event.url;
        });

        // Add a loader image which is displayed during loading
        ias.extension(
            new IASSpinnerExtension({
                html: '<div class="loader _deprecated"><div class="sk-fading-circle _deprecated"><div class="sk-circle1 sk-circle _deprecated"></div><div class="sk-circle2 sk-circle _deprecated"></div><div class="sk-circle3 sk-circle _deprecated"></div><div class="sk-circle4 sk-circle _deprecated"></div><div class="sk-circle5 sk-circle _deprecated"></div><div class="sk-circle6 sk-circle _deprecated"></div><div class="sk-circle7 sk-circle _deprecated"></div><div class="sk-circle8 sk-circle _deprecated"></div> <div class="sk-circle9 sk-circle _deprecated"></div><div class="sk-circle10 sk-circle _deprecated"></div><div class="sk-circle11 sk-circle _deprecated"></div><div class="sk-circle12 sk-circle _deprecated"></div></div></div>',
            })
        );

        // Add a link after page 2 which has to be clicked to load the next page
        ias.extension(
            new IASTriggerExtension({
                text: translations[video == 1 ? 'loadmore.video' : 'loadmore.gallery'],
                html:
                    '<li class="ias-trigger ias-trigger-next"><a href="#" class="button title loadmore ' +
                    (platform == 'gp' ? 'filled' : '') +
                    '">{text}</a></li>',
            })
        );

        // Add a text when there are no more pages left to load
        ias.extension(
            new IASNoneLeftExtension({
                text: translations[video == 1 ? 'nomore.video' : 'nomore.gallery'],
            })
        );
        ias.on('render', function () {
            setTimeout(refreshDeprecatedStyles, 0);
        });
    }

    // PLAYER-CLUB PAGE TITLE
    $(function () {
        var $name = $('.player_single .player_left h3');
        var $nameBig = $('.top_table h1');

        var $numLetters = $name.text().length;
        var $numLettersBig = $nameBig.text().length;

        if ($numLetters >= 1 && $numLetters < 18) {
            $name.css('font-size', '1.250em');
        } else if ($numLetters >= 18 && $numLetters < 30) {
            $name.css('font-size', '1.1em');
        } else if ($numLetters >= 30 && $numLetters < 40) {
            $name.css('font-size', '1em');
        } else {
            $name.css('font-size', '1.250em');
        }

        if ($numLettersBig >= 1 && $numLettersBig < 18) {
            $nameBig.css('font-size', '1.500em');
        } else if ($numLettersBig >= 18 && $numLettersBig < 30) {
            $nameBig.css('font-size', '1.3em');
        } else if ($numLettersBig >= 30 && $numLettersBig < 40) {
            $nameBig.css('font-size', '1em');
        } else {
            $nameBig.css('font-size', '1.500em');
        }
    });

    $('.pass_profile input').keyup(function () {
        $('.pass_profile input[type="submit"]').removeAttr('disabled');
    });

    function validateEmail(email) {
        var re =
            /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(email);
    }

    $('.newsletter').submit(function (event) {
        $('.error_newsletter').removeClass('error_newsletter');
        $('#message').remove();

        event.preventDefault();
        var newsletter = $(this);
        var newsletterInput = $(this).find('input');
        var error = 0;
        var errorMessage;

        $(newsletterInput).each(function () {
            var input = $(this);
            if (input.val().length > 0 && input.val().length < 4) {
                input.addClass('error_newsletter');
                error++;
            } else {
                error = 0;
            }
        });

        if (!validateEmail($('.subscribe_input').val())) {
            $('.subscribe_input').addClass('error_newsletter');
            error++;
        }

        //(errorMessage.length < 1)
        if (error !== 0 && document.getElementById('message') == null) {
            var errorMessage = $('<div id="message">' + translations['field.fillin'] + '</div>');
            $(newsletter).append(errorMessage);
        } else if (error !== 0) {
            return;
        } else {
            newsletter[0].submit();
        }
    });

    //
    // Comments - edit & react
    if (
        window.location.hash != '' &&
        window.location.hash != '#comments_anchor' &&
        window.location.hash != '#slide1' &&
        window.location.hash != '#slide2' &&
        window.location.hash != '#slide3' &&
        window.location.hash != '#slide4' &&
        window.location.hash != '#slide5'
    ) {
        var commentID = window.location.hash;

        var hash = window.location.hash.replace('#', '');
        var galleryRegex = new RegExp('gallery-photo');
        var tabRegex = new RegExp('tab');
        if (galleryRegex.test(hash)) {
            var number = hash.replace('gallery-photo', '');
            number = Number(number) - 1;
            $('#gallery-slider').slick('slickGoTo', number, false);
        } else if (tabRegex.test(hash)) {
            setTimeout(function () {
                var offset = $(commentID).offset();
                console.log(offset);
                var scrollto = offset.top - 100; // minus fixed header height
                console.log(scrollto);
                $('html, body').animate(
                    {
                        scrollTop: scrollto,
                    },
                    'slow'
                );
            }, 200);
        }
    }

    // Mailgun email validation
    var $registerForm = $('#register-form');
    if ($registerForm.length) {
        var registerElements = {};
        registerElements.form = $registerForm;
        registerElements.loader = $registerForm.find('.sk-fading-circle');
        registerElements.label = $registerForm.find('label[for=email]');
        registerElements.error = $registerForm.find('div.error');
        registerElements.hint = $registerForm.find('div.hint');
        registerElements.hintClick = registerElements.hint.find('a');
        registerElements.input = $registerForm.find('[name=email]');
        registerElements.button = $registerForm.find('[type="submit"]');
        registerElements.isValid = false;
        registerElements.isValidInput = $registerForm.find('[name=email_is_valid]');

        // Fill hint into input on click
        registerElements.hintClick.on('click', function (e) {
            e.preventDefault();
            registerElements.input.val($(this).text());
            registerElements.hint.addClass('hidden');
            registerElements.label.removeClass('error');
        });

        // Register mailgun plugin on input
        registerElements.input.mailgun_validator({
            api_key: 'pubkey-b7082a6f8da64b9b428fd7ae3bb8b5c6',
            in_progress: function () {
                registerElements.loader.removeClass('hidden');
            },
            success: function (result) {
                registerElements.isValid = false;

                // Hide all elements
                registerElements.loader.addClass('hidden');
                registerElements.error.addClass('hidden');
                registerElements.hint.addClass('hidden');

                if (!result.is_valid) {
                    registerElements.label.addClass('error');
                    if (result.did_you_mean) {
                        registerElements.hintClick.text(result.did_you_mean);
                        registerElements.hint.removeClass('hidden');
                    } else {
                        registerElements.error.removeClass('hidden');
                    }
                } else {
                    registerElements.isValid = true;
                    registerElements.label.removeClass('error');
                }

                registerElements.isValidInput.val(registerElements.isValid ? 'true' : 'false');
            },
            error: function () {
                registerElements.isValidInput.val('false');
                registerElements.isValid = false;
                registerElements.loader.addClass('hidden');
            },
        });
    }
});

// Call slick to check if it needs to be initialized on window resize
$(window).resize(toggleSlick);

function setCookie(cname, cvalue, exdays) {
    var d = new Date();
    d.setTime(d.getTime() + exdays * 86400 * 365);
    var expires = 'expires=' + d.toUTCString();
    document.cookie = cname + '=' + cvalue + '; ' + expires + '; path=/';
}

jQuery(document).ready(function () {
    activeHash = window.location.hash;
    jQuery('.js-tabs .tab_links a').on('click', function (e) {
        var currentAttrValue = jQuery(this).attr('href');
        window.location.hash = currentAttrValue;
        // Show/Hide Tabs
        jQuery('.js-tabs ' + currentAttrValue)
            .fadeIn(400)
            .siblings()
            .hide();

        // Change/remove current tab to active
        jQuery(this).parent('li').addClass('active').siblings().removeClass('active');

        e.preventDefault();
    });
    if (activeHash) {
        jQuery('.js-tabs ' + activeHash)
            .fadeIn(400)
            .siblings()
            .hide();
        jQuery('a[href="' + activeHash + '"]')
            .parent('li')
            .addClass('active')
            .siblings()
            .removeClass('active');
    }
});

// Script for the new widgets (in essence the same script, but with a few tweaks)
jQuery(document).ready(function ($) {
    activeHash = window.location.hash;
    $('.js-tabs .tab_links a').on('click', function (e) {
        var currentAttrValue = $(this).attr('href');
        window.location.hash = currentAttrValue;

        // Show/Hide Tabs on featured pages
        $('.tab_content .main-content').each(function () {
            if ($(this).children(currentAttrValue).length > 0) {
                $(this).children(currentAttrValue).fadeIn(400);
            } else {
                $(this).children().hide();
            }
        });

        // Change/remove current tab to active
        $(this).parent('li').addClass('active').siblings().removeClass('active');

        e.preventDefault();
    });
    if (activeHash) {
        jQuery('.tab_content .main-content ' + activeHash)
            .fadeIn(400)
            .siblings()
            .hide();
        jQuery('a[href="' + activeHash + '"]')
            .parent('li')
            .addClass('active')
            .siblings()
            .removeClass('active');
    }
});

/**
 * https://css-tricks.com/snippets/javascript/javascript-array-contains/
 * Array.prototype.[method name] allows you to define/overwrite an objects method
 * needle is the item you are searching for
 * this is a special variable that refers to "this" instance of an Array.
 * returns true if needle is in the array, and false otherwise
 */
Array.prototype.contains = function (needle) {
    for (i in this) {
        if (this[i] == needle) return true;
    }
    return false;
};
